import React, { useState } from 'react';
import StepOne from './components/StepOne';
import StepTwo from './components/StepTwo';
import { ErrorMessage } from '../Common/Form';
import dayjs from 'dayjs';

const SignUpForm = () => {
    const [error, setError] = useState('');
    const [step, setStep] = useState(1);
    const [data, setData] = useState({
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        memberCompany: null,
        memberTitle: null,
        country: null,
        timezone: null,
        phone: null,
    });

    const collectData = (collected) => {
        const newData = {};

        Object.entries(collected).forEach((entry) => {
            const [key, value] = entry;

            if (Object.hasOwn(data, key)) {
                newData[key] = value;
            }
        });

        setData(Object.assign(data, newData));
        setStep((prev) => prev + 1);
    };

    const createAccount = async () => {
        const postData = {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            password: data.password,
            'fields[memberCompany]': data.memberCompany,
            'fields[memberTitle]': data.memberTitle,
            'fields[memberCountry]': data.country,
            'fields[memberTimeZone]': data.timezone,
            'fields[memberPhoneNumber]': data.phone,
            'fields[memberAgreedToTerms]': 1,
            'fields[memberCommunications]': 1,
            'fields[agreedToCurrentTermsAndConditions]': 1,
            'fields[accountAnniversary]': dayjs().format('MM/DD/YYYY'),
            action: 'users/save-user',
        };

        const response = await fetch('/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': window.token,
            },
            body: new URLSearchParams(postData),
        });

        // This is returning a 302, which leaves `response.ok` as false
        if (!response.statusCode < 400) {
            return (window.location = '/members/dashboard');
        }

        setError('An unknown error occurred - The account was not created. Please try again.');
        setStep(2);
    };

    if (step > 2) {
        createAccount();
    }

    return (
        <>
            <h2 className="login__heading -secondary">Create your Profile</h2>
            {step === 1 && <StepOne collectData={collectData} />}
            {step > 1 && <StepTwo collectData={collectData} />}
            <ErrorMessage message={error ?? ''} />
        </>
    );
};

export default SignUpForm;
